import { reactive, ref } from 'vue'
import { dataAssetsApi, dataFlowApi } from '@/api'
import { DataAssetInfo, DataObjectOwnerType } from '@coac-gmbh/saifty-main-apis'
import {
  DEFAULT_FLOW_TYPE,
  FlowWithData,
  SDS_TREE,
  SDS_PASSPORT_ID,
  DEFAULT_FLOW_CONFIDENCE,
  SUPPORTED_LANGUAGES_OPTIONS,
} from '@/config'

export default function useWizard() {
  const DEFAULT_DATA_ASSET_NAME = 'Default'
  const defaultExtractionID = ref<string>('')
  const defaultExtraction = reactive<FlowWithData>({
    name: 'SDS Extraction',
    flowType: DEFAULT_FLOW_TYPE,
    data: {
      extract: {
        allEchaIngredients: false,
        allEPAIngredients: false,
        quickExtraction: true,
        passportId: SDS_PASSPORT_ID,
        displayAllPassportItems: true,
        sections: SDS_TREE.map((section) => section.id),
        languages: SUPPORTED_LANGUAGES_OPTIONS,
        ocr: false,
        backlog: false,
        componentExtraction: false,
      },
      validate: {
        confidence: DEFAULT_FLOW_CONFIDENCE,
        lookup_phrases: true,
        echa_reach_call: false,
        epa_call: false,
        region: '',
        businessUnit: '',
        translate_from_phrases: [],
        translate_to_phrases: '',
        translate_from_document: [],
        translate_to_document: '',
      },
      store: {
        dataassetId: '',
        dataassetName: '',
      },
    },
  }) as FlowWithData

  async function createDefaultExtractionAndDataAsset() {
    await loadDataAsset()
    await createFlow()
  }

  async function loadDataAsset() {
    let dataAsset: DataAssetInfo | undefined
    const { data: dataAssetsResponse } = await dataAssetsApi.getAllDataAssets({
      ownerType: DataObjectOwnerType.OwnedByMeOnly,
    })

    if (dataAssetsResponse.dataAssets && dataAssetsResponse.dataAssets.length > 0) {
      // If not found then undefined is kept
      dataAsset = dataAssetsResponse.dataAssets.find((dA) => {
        return dA.name === DEFAULT_DATA_ASSET_NAME
      })
    }
    // Default Data asset not found, then let's create it
    if (!dataAsset) {
      const { data } = await dataAssetsApi.createDataAsset({ dataAssetRequest: { name: DEFAULT_DATA_ASSET_NAME } })
      dataAsset = data
    }

    if (dataAsset.id) defaultExtraction.data.store.dataassetId = dataAsset.id
    if (dataAsset.name) defaultExtraction.data.store.dataassetName = dataAsset.name
  }

  async function createFlow() {
    const { data } = await dataFlowApi.createDataFlow({ dataFlowRequest: defaultExtraction })
    if (data.id) defaultExtractionID.value = data.id
  }

  return {
    DEFAULT_DATA_ASSET_NAME,
    defaultExtractionID,
    defaultExtraction,
    createDefaultExtractionAndDataAsset,
  }
}
